import React from 'react'
import { Typography, Box } from '@mui/material'
import './index.css'

const sx = {
  subHeader: {
    fontSize: '14px',
    fontWeight: 600,
    margin: '20px 0 10px 0',
    borderBottom: '1px solid #25245F',
  },
  name: {
    color: '#0A78CD',
    fontWeight: 500,
    fontSize: '16px',
    lineheight: '24px',
  },
}

const KeyPeople = ({ data }) => {
  const { details } = data
  return (
    <Box sx={{ padding: '0px 10px 10px 10px' }}>
      {details?.keyPeople?.filter(person => person.displayInDirectory)?.length > 0 && (
        <Box>
          <Typography sx={sx.subHeader}>MANAGEMENT</Typography>
          {details.keyPeople.map(person => {
            return (
              <Box
                key={
                  person.title +
                  person.email +
                  person.firstName +
                  person.lastName +
                  person.phone +
                  person.displayInDirectory
                }
                className="mt-3"
              >
                {person.displayInDirectory === true && (
                  <Box sx={{ padding: '20px 0px 0px 0px' }}>
                    <Typography sx={sx.name}>{person.firstName}</Typography>
                    <Typography variant="body2">Position Title: {person.title}</Typography>
                    <Box display="flex" gap="7px" alignItems="baseline">
                      <Typography variant="body2">Email: {person.email}</Typography>
                    </Box>
                    <Box display="flex" gap="7px" alignItems="baseline">
                      <Typography variant="body2">Phone Number: {person.phone}</Typography>
                    </Box>
                  </Box>
                )}
              </Box>
            )
          })}
        </Box>
      )}

      {details?.beneficialOwners?.length > 0 && (
        <Box>
          <Typography sx={sx.subHeader}>BENEFICIAL OWNERSHIP</Typography>
          {details.beneficialOwners.map(BO => {
            return (
              <Box key={BO.fullName + BO.type} className="mt-3">
                <Box sx={{ padding: '20px 0px 0px 0px' }}>
                  <Typography sx={sx.name}>{BO.fullName}</Typography>
                  <Typography variant="body2">Owner Type: {BO.type === 'I' ? 'Individuval' : 'Business'}</Typography>
                </Box>
              </Box>
            )
          })}
        </Box>
      )}
    </Box>
  )
}

export default KeyPeople
